import _ from "lodash";
import { SimpleMapper } from "./SimpleMapper";
import { IManagementTranslation } from "../domain/models/ManagementTranslation";
import { ManagementTranslationDTO } from "../domain/models/dto/ManagementDTO";

export class ManagementTranslationMapper extends SimpleMapper<
    IManagementTranslation,
    ManagementTranslationDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "fullName",
        "position",
        "languageCode",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "managementId",
        "availableLangs",
    ];

    fromDTO(dto: ManagementTranslationDTO): IManagementTranslation {
        if (!dto) {
            return null;
        }
        const result = super.fromDTO(dto);
        result.languageCode = !_.isEmpty(dto.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }

    toDTO(model: IManagementTranslation): ManagementTranslationDTO {
        if (!model) {
            return null;
        }
        const result = super.toDTO(model);
        result.languageCode = !_.isEmpty(model.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }
}
